export default {
  throwError({ commit }, error) {
    commit('setError', error);
  },
  throwDefaultError({ commit }, e) {
    if (e.response && e.response.data && e.response.data.error) {
      const error = e.response.data;
      const renderedError = {
        code: e.response.status,
        title: error.error,
        detail: error.message,
      };
      if (renderedError.title === 'ConfigUsedInHawwwai') {
        renderedError.title = 'Erreur lors de la suppresion';
        renderedError.detail = 'Cette configuration est utilisée dans Hawwwai';
      }
      commit('setError', renderedError);
    } else {
      let renderedError = {
        code: e.status || 500,
        title: e.statusText || 'Une erreur inconnue est survenue',
        detail: e.data || null,
      };
      if (e.response.status === 403) {
        renderedError = {
          code: 403,
          title: 'Accès refusé',
          detail: e.response.statusText || "Vous n'avez pas les droits nécessaires pour accéder à cette page",
        };
      }
      commit('setError', renderedError);
    }
  },
};
